<template>
    <div
        class="filter-backgroud-close"
        :class="{
            'hide-filter-backgroud-close': !showFilter,
        }"
        @click.self="$emit('closeFilter', false)"
    >
        <div
            ref="listaFiltros"
            class="filter-right"
            :class="{
                'hide-filter-right-large': !showFilter && !filterCompact,
                'hide-filter-right-compact': !showFilter && filterCompact,
                'filtro-right-large': !filterCompact,
                'filtro-right-compact': filterCompact,
            }"
            v-show="!isLoading"
        >
            <div class="filter-container">
                <slot></slot>
            </div>
            <div class="filter-footer">
                <div>
                    <b-button
                        type="is-warning is-silver"
                        icon-right="close"
                        @click="$emit('closeFilter', false)"
                        :disabled="isLoading"
                        v-tippy 
                        :title="$t('fechar')"
                    />
                </div>
                <div class="filter-footer-right">
                    <b-button
                        type="is-warning is-silver"
                        icon-right="backspace"
                        @click="$emit('onClearFilters', false)"
                        class="mr-2"
                        :disabled="isLoading"
                    >
                        Limpar
                    </b-button>
                    <b-button
                        type="is-primary"
                        icon-right="filter"
                        @click="$emit('searchTable', false)"
                        :disabled="isLoading"
                    >
                        Filtrar
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        showFilter: {
            type: Boolean,
            default: false,
        },
        filterCompact: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>

.filter-backgroud-close {
    z-index: 1000;
    position: absolute;
    background-color: rgba(73, 73, 73, 0.5);
    top: 0;
    right: -20px;
    left: -20px;
    bottom: 0;
    cursor: pointer;
}
.hide-filter-backgroud-close {
    left: auto;
}

.filtro-right-large {
    width: 900px;
}
.filtro-right-compact {
    width: 450px;
}

.hide-filter-right-large {
    margin-right: -(calc(900px + 10px));
}
.hide-filter-right-compact {
    margin-right: -(calc(450px + 10px));
}

.filter-right {
    z-index: 1000;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    background-color: $darker-bg-color;
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    border-top: solid 1px #d9d9d9;
    border-left: solid 1px #d9d9d9;
    border-bottom: solid 1px #d9d9d9;
    transition: 0.6s;
    -webkit-box-shadow: 0px 0px 25px 0px rgba(138, 138, 138, 0.8);
    box-shadow: 0px 0px 25px 0px rgba(138, 138, 138, 0.8);
    display: flex;
    flex-direction: column;
    cursor: auto;
    max-height: 80%;

    .filter-container {
        padding: 15px;
        overflow-x: scroll;
        flex-grow: 1;
    }

    .filter-footer {
        border-bottom-left-radius: 5px;
        background-color: #fff;
        padding: 10px;
        -webkit-box-shadow: 0px 0px 7px 0px rgba(153, 153, 153, 0.4);
        box-shadow: 0px 0px 7px 0px rgba(153, 153, 153, 0.4);
        display: flex;
        justify-content: space-between;

        .is-silver {
            color: $semi-title-color;
            box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
            @include exclude-button();
        }
        .filter-footer-right {
            display: flex;
        }
    }
}

@media screen and (max-width: 1024px) {
    .filtro-right-large,
    .filtro-right-compact {
        width: 95%;
    }
    .hide-filter-right-large,
    .hide-filter-right-compact {
        margin-right: -95%;
    }
}
</style>
